/* eslint-disable react/jsx-props-no-spreading */
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import MDBadgeDot from "components/MDBadgeDot";
import { useState } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";

const CollapsibleList = ({ header, list, expanded = false }) => {
  const [open, setOpen] = useState(expanded);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <List>
      <ListItemButton onClick={handleToggle}>
        <ListItemText>
          <Typography sx={{ fontWeight: 700, fontSize: "0.9rem" }}>{`${header} (${Number(
            list.length
          )})`}</Typography>
        </ListItemText>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {list.map((item, index) => (
            <Droppable
              droppableId={`kpis-${String(item.id)}`}
              isDropDisabled
              key={`kpis-${String(item.id)}`}
            >
              {(providedOuter) => (
                <div ref={providedOuter.innerRef} {...providedOuter.droppableProps}>
                  <Draggable key={String(item.id)} draggableId={String(item.id)} index={index}>
                    {(providedInner) => (
                      <div
                        ref={providedInner?.innerRef}
                        {...providedInner?.draggableProps}
                        {...providedInner?.dragHandleProps}
                      >
                        <ListItemButton sx={{ px: "3px", py: "4px", ml: "1rem" }}>
                          <MDBadgeDot
                            color="warning"
                            size="lg"
                            sx={{
                              p: 0.5,
                              i: {
                                background: generateColorFromString(item.name),
                              },
                            }}
                            badgeContent=""
                          />
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              fontWeight: "400",
                              lineHeight: "1.25",
                            }}
                          >
                            {item.name}
                          </Typography>
                        </ListItemButton>
                      </div>
                    )}
                  </Draggable>
                  {providedOuter?.placeholder}
                </div>
              )}
            </Droppable>
          ))}
        </List>
      </Collapse>
    </List>
  );
};

export default CollapsibleList;
